import React, { Component } from 'react';
let DateTimeField = require('react-bootstrap-datetimepicker');
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

class DatePickerAgro extends Component {
    constructor(props) {
        super(props);
        this.changeDate = this.changeDate.bind(this);
    }

    changeDate(date) {
        let dateParts = date.split("/");
        let newDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        this.props.changeDate("AGRO", date != "" ? newDate.toISOString().slice(0, 19).replace('T', ' ') : "");
    }

    render() {
        let fechaTopeAgro;
        let defaultText;

        if (this.props.data.FechaTopeAgro != null && this.props.data.FechaTopeAgro != "") {
            fechaTopeAgro = defaultText = GlobalHelper.FormatDate(this.props.data.FechaTopeAgro);
        } else {
            defaultText = "Seleccione una fecha";
            fechaTopeAgro = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
        }

        return (
            <div className="row top-separator-xs">
                <div className="col-md-3 vertical-align">
                    <label className="label-primary">Fecha tope Agro</label>
                </div>
                <div className="col-md-3 vertical-align">
                    <DateTimeField
                        mode="date"
                        defaultText={defaultText}
                        dateTime={fechaTopeAgro}
                        format={"DD/MM/YYYY"}
                        inputFormat={"DD/MM/YYYY"}
                        onChange={() => this.changeDate()}
                    />
                </div>
            </div>
        );
    }
};

export default DatePickerAgro;